module.exports = __webpack_public_path__ + "img/45.a7c9ee48.png";